import { QueryableEntityType } from 'mark43-federated-search';
import { NavigateFunction } from 'react-router-dom';
import { FR_DEX_WINDOW_PATH } from './constants';

type NavigateToDexFormParams = {
    dexNextEnabled: boolean;
    navigate: NavigateFunction;
    selectForm: (type: QueryableEntityType, field: string) => void;
    entityType: QueryableEntityType;
    field: string;
    fallbackTab: string;
    fallbackFocusField?: string;
};

export const navigateToDexForm = ({
    dexNextEnabled,
    navigate,
    selectForm,
    entityType,
    field,
    fallbackTab,
    fallbackFocusField,
}: NavigateToDexFormParams) => {
    if (dexNextEnabled) {
        navigate(FR_DEX_WINDOW_PATH);
        selectForm(entityType, field);
    } else {
        const state: Record<string, string> = { tab: fallbackTab };

        if (fallbackFocusField) {
            state.focusSection = fallbackFocusField;
        }

        navigate(FR_DEX_WINDOW_PATH, {
            state,
            replace: true,
        });
    }
};
